module.exports = false;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_library.js
 ** module id = 320
 ** module chunks = 1
 **/